export default __webpack_public_path__ + "static/media/integrateButtonIcon.4837c4e5.svg";